export enum TimeVisibility {
    DEFAULT = 0,
    FIXED = 1
}
